import { createContext, useContext } from "react";
import type { WizardData } from "@/types/wizard";

type Setter = <K extends keyof WizardData>(key: K, value: WizardData[K]) => void;

export type WizardContextValue = {
  data: WizardData;
  set: Setter;
  reset: () => void;
  readonly: boolean;
};

export const WizardContext = createContext<WizardContextValue | null>(null);

export function useWizard() {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error("useWizard debe usarse dentro de <WizardProvider>");
  return ctx;
}
